import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-qsa-gina',
  templateUrl: './qsa-gina.component.html',
  styleUrls: ['./qsa-gina.component.scss']
})
export class QsaGinaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
